import { useMutation } from '@tanstack/react-query';
import { UsersApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useUsersControllerPermanentlyDeleteUserMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['usersControllerPermanentlyDeleteUser', accessControlScope],
        mutationFn: async (args) => {
            const api = new UsersApi(accessControlConfig);
            return api.usersControllerPermanentlyDeleteUser(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useUsersControllerPermanentlyDeleteUserMutation.js.map